/* Shared mobile page freeze; overlapping drawers release only their own lock. */
(() => {
  if (window.GrovaPageScroll) return;
  const owners = new Map();
  let saved;
  const mobile = () => window.matchMedia('(max-width: 989px), (pointer: coarse)').matches;
  const remember = (element, properties) => properties.map(property =>
    [element, property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)]);
  function lock(owner) {
    if (owners.has(owner)) return owners.get(owner);
    if (!owners.size && mobile()) {
      const html = document.documentElement, body = document.body;
      saved = {
        x: window.scrollX, y: window.scrollY,
        styles: [
          ...remember(html, ['overflow', 'overscroll-behavior', 'scroll-behavior']),
          ...remember(body, ['position', 'top', 'left', 'right', 'width', 'overflow', 'overscroll-behavior']),
        ],
      };
      html.style.setProperty('overflow', 'hidden', 'important');
      html.style.setProperty('overscroll-behavior', 'none', 'important');
      for (const [property, value] of Object.entries({ position: 'fixed', top: `${-saved.y}px`, left: `${-saved.x}px`, right: '0', width: '100%', overflow: 'hidden', 'overscroll-behavior': 'none' })) {
        body.style.setProperty(property, value, 'important');
      }
    }
    const release = () => {
      if (!owners.delete(owner) || owners.size || !saved) return;
      const previous = saved;
      saved = null;
      previous.styles.forEach(([element, property, value, priority]) => {
        if (value) element.style.setProperty(property, value, priority);
        else element.style.removeProperty(property);
      });
      // Override smooth scrolling only for the synchronous position restoration.
      const html = document.documentElement;
      const behavior = html.style.getPropertyValue('scroll-behavior');
      const priority = html.style.getPropertyPriority('scroll-behavior');
      html.style.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo({ left: previous.x, top: previous.y, behavior: 'instant' });
      if (behavior) html.style.setProperty('scroll-behavior', behavior, priority);
      else html.style.removeProperty('scroll-behavior');
    };
    owners.set(owner, release);
    return release;
  }
  function canScrollWithin(target, panel, delta) {
    if (!panel?.contains(target)) return false;
    for (let node = target instanceof Element ? target : target.parentElement; node; node = node.parentElement) {
      const overflow = getComputedStyle(node).overflowY;
      if (/(auto|scroll)/.test(overflow) && node.scrollHeight > node.clientHeight) {
        if (delta < 0 && node.scrollTop > 0) return true;
        if (delta > 0 && node.scrollTop + node.clientHeight < node.scrollHeight - 1) return true;
      }
      if (node === panel) break;
    }
    return false;
  }
  window.GrovaPageScroll = { lock, mobile, canScrollWithin };
})();
